
import { getLetterUser } from "@/helpers";
import { User } from "@/models";
import { login } from "@/store";
import { Component, Vue } from "vue-property-decorator";
import Tag from "@/components/tags/Tag.vue";
import Cta from "@/components/buttons/Button.vue";
import ClickOutside from "vue-click-outside";

@Component({
  components: { Tag, Cta },
  directives: {
    ClickOutside,
  },
})
/** Main app navigation — collapsible on mobile, role-gated sections (via {@link hasAccess}), user menu. */
export default class Sidebar extends Vue {
  private state = false;

  /** Toggles the mobile nav open/closed, locking body scroll while open. */
  private switchState(): void {
    this.state = !this.state;
    document.body.style.overflow = this.state ? "hidden" : "";
  }

  private close(): void {
    this.state = false;
    document.body.style.overflow = "";
  }

  beforeDestroy(): void {
    document.body.style.overflow = "";
  }

  get context(): User | null {
    return login.getContext;
  }

  /** Whether the current user has any of the given roles or habilitations — gates nav sections/links. */
  hasAccess(allowed: string[]): boolean {
    const ctx = this.context;
    if (!ctx) return false;
    return allowed.some(
      (r) => ctx.roles.includes(r) || ctx.habilitations.includes(r)
    );
  }

  private letterUser(nom_usage: string): string {
    return getLetterUser(nom_usage);
  }
}
